import ArticleCategory from 'models/ArticleCategory';

import { Props as ButtonProps } from 'components/layout/Button';

import Component from './component';

export interface Props {
    title: string;
    placeholder:string;
    categories: ArticleCategory[];
    onSearch?: (response: any) => any;
    icon: string;
    buttonProps: ButtonProps;
}

Component.defaultProps = {
    onSearch: null,
};

export default Component;